import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { mergeOverrides, Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';
import { EventStatusEnum, EventUnion } from '@/types/schema';

import { messageBoxHiddenClasses } from '../../../../../../MessageListItem/styles';
import { BaseItemOverrides, BaseItemProps } from '../../types';
import { getEventTimeInfo } from './utils';

const DEFAULT_OVERRIDES: BaseItemOverrides = {
  Image: { className: 'w-48 h-36' },
  Description: { color: 'text-text-secondary' },
};

const EventListItem: React.FC<BaseItemProps<EventUnion>> = (props) => {
  const { item: event, getDescription = getEventTimeInfo, overrides: overridesProp } = props;
  const { t } = useTranslation();
  const overrides = mergeOverrides(DEFAULT_OVERRIDES, overridesProp);

  const { cover, name } = event;
  const url = cover?.url;
  if (!url) {
    return null;
  }

  return (
    <>
      <Image
        alt={name}
        className={cn(
          'flex-shrink-0 rounded-4 border border-border',
          { [`${messageBoxHiddenClasses}`]: event.status === EventStatusEnum.Completed },
          overrides.Image?.className,
        )}
        height={36}
        src={url}
        width={48}
      />
      <Stack className="min-w-0 ms-12" direction="col" gapY={2}>
        <Typography className="truncate" color="text-text-primary" variant="body-short-02">
          {name}
        </Typography>
        <Typography {...overrides.Description} className="truncate" variant="body-short-03">
          {getDescription(t, event)}
        </Typography>
      </Stack>
    </>
  );
};

export default EventListItem;
